import { render, staticRenderFns } from "./CellRendererAccounts.vue?vue&type=template&id=97070d1e"
import script from "./CellRendererAccounts.vue?vue&type=script&lang=js"
export * from "./CellRendererAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports